import { OK, BAD, WARN, TEAL } from '../../lib/uiTokens';

// Pacing bar: výplň = tempo (skutečnost / plán měsíc, zastropováno na 100 %),
// tyrkysová značka = uplynulá část měsíce ("dnes"). Čti výplň VŮČI značce —
// za značkou = napřed, před značkou = pozadu.
//
// Barva dle SMYSLU řádku:
//  - jeVyhoda (tržby, „víc = líp"): napřed/na tempu = zelená, pozadu = oranžová.
//    Překročení plánu je úspěch → nikdy červená.
//  - náklady („víc = hůř"): přes celý měsíční plán = přečerpáno (červená),
//    jinak barva sekce.
// Přes 100 % je pruh plný → magnitudu doříkává šipka vpravo + % ve sloupci vedle.
export default function PacingBar({ tempo, podil, color, isDark, jeVyhoda = false }) {
    if (tempo == null) {
        return <div style={{ height: 8 }} />;
    }
    const znacka = Math.max(0, Math.min(podil ?? 0, 1));   // "dnes" 0..1
    const pct = Math.max(0, Math.min(tempo, 1)) * 100;     // výplň 0..100 %
    const preplneno = tempo > 1.001;                        // přes celý měsíční plán

    const fill = jeVyhoda
        ? (tempo >= znacka - 0.005 ? OK : WARN)             // tržby: napřed zelená, pozadu oranžová
        : (preplneno ? BAD : (color || OK));               // náklady: přečerpáno červená

    return (
        <div style={{ position: 'relative', height: 8, borderRadius: 4,
            background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)' }}>
            <div style={{ position: 'absolute', inset: '0 auto 0 0', width: `${pct}%`,
                borderRadius: 4, background: fill, transition: 'width .3s' }} />
            {/* Přetečení přes 100 % — pruh je zastropovaný, tak naznač šipkou vpravo */}
            {preplneno && (
                <div title="přes celý měsíční plán" style={{ position: 'absolute', right: 3, top: '50%',
                    transform: 'translateY(-50%)', width: 0, height: 0,
                    borderTop: '3.5px solid transparent', borderBottom: '3.5px solid transparent',
                    borderLeft: '5px solid rgba(255,255,255,0.9)' }} />
            )}
            <div title="dnes" style={{ position: 'absolute', top: -3, bottom: -3, left: `${znacka * 100}%`,
                width: 2, background: TEAL, borderRadius: 2, boxShadow: `0 0 6px ${TEAL}aa` }} />
        </div>
    );
}
